import { useContext, useEffect } from 'react';
import { MainContext } from '../../../context/main.context';
import { createPaymentYandexPay } from '../../../stores/payment.store';
import {  PAYMENTS_YANDEX_PAY_CREATE_ERROR } from '../../../common/errorCodes';
import ManualController from '../../../hoc/ManualController';
import { ICreatePaymentYandexPay } from '../../../interfaces';
import PaymentState from '../../../hoc/PaymentState';


export default function PaymentsYandexPay() {
    const { paymentId, toggleLoader } = useContext(MainContext);
    const { manualRedirect } = ManualController();
    const { startCheckUserPaymentState } = PaymentState();

    useEffect(() => _createPayment(), []);

    const _createPayment = (): void => {
        toggleLoader(true);

        const id: string = paymentId as string;

        createPaymentYandexPay(id).then(res => {
            const result: ICreatePaymentYandexPay = res?.data;
            const { data, code, status } = result;

            if (status !== 'success' || code !== 200 || !data?.paymentUrl) {
                manualRedirect(res, 'payment', true, PAYMENTS_YANDEX_PAY_CREATE_ERROR);
                return;
            }

            startCheckUserPaymentState(data.paymentUrl, id);
        }, err => {
            const errData = err?.response?.data || err;
            manualRedirect(errData, 'payment', true, PAYMENTS_YANDEX_PAY_CREATE_ERROR);
        }).finally(() => {
            toggleLoader(false);
        });
    }

    return null;
}

PaymentsYandexPay.displayName = 'PaymentsYandexPay';